import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MaterialSelect";
import { taskCreationData, taskcreationStateMange } from "../taskCreationData";
import MaterialInput from "../../../components/MaterialInput";
import FileSelector from "../../../components/fileSelector";
import MaterialButton from "../../../components/MaterialButton";
import MultiSelectAutocomplete from "../../../components/MultiSelectAutocomplete";
import { BASE_URL, fetchData, postData, putData } from "../../Utils/Baseurl";
import { useLoading } from "../../../context/loadingcontext";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useSnackbar } from "../../../components/SnackbarProvider";
import ChatBot from "../../chatbot";
import MaterialDatePicker from "../../../components/MaterialDatePicker";

const TaskCreationForm = () => {
  const [taskData, dispatch] = useReducer(
    taskcreationStateMange,
    taskCreationData
  );
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [inputDisble, setInputDisble] = useState(false);
  const [projectNameOption, setProjectNameOption] = useState([]);
  const [priorityOption, setPriorityOption] = useState([]);
  const [team, setTeam] = useState([])
  const [projectLoading, setProjectLoading] = useState(false);
  const [priorityLoading, setPriorityLoading] = useState(false);
  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [allocatedMembers, setAllocatedMembers] = useState([]);
  const [mileStoneOption, setMileStoneOption] = useState([]);
  const [taskCountId, setTaskCountId] = useState("");
  const [assginMembersOption, setAssginMembersOption] = useState([]);
  const [suggestion, setSuggestion] = useState("");
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const currentUser = sessionStorage.getItem("currentUser");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);


  const type = location?.state?.type;
  const data = location?.state?.data;

  useEffect(() => {
    if (type === "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [type]);

  useEffect(() => {
    if (data) {
      dispatch({
        value: { value: data?.project, label: data?.project_name },
        name: "projectName",
      });
      fetchTeamsDependince(data?.project);
      dispatch({
        value: { value: data?.priority_level, label: data?.priority_level },
        name: "priority",
      });
      dispatch({
        value: { value: data?.Assignee, label: data?.assignee_name },
        name: "assignemnt",
      });

      dispatch({
        value: data?.module,
        name: "moduleName",
      });
      dispatch({
        value: data?.task_title,
        name: "tasktitle",
      });
      dispatch({
        value: data?.task_describtion,
        name: "taskDescrpition",
      });
      dispatch({
        value: data?.task_creater_name,
        name: "reporter",
      });
      dispatch({
        value: data?.start_date,
        name: "startDate",
      });
      dispatch({
        value: data?.end_date,
        name: "endDate",
      });
      dispatch({
        value: data?.assigned_hours,
        name: "assginHours",
      });
      dispatch({
        value: { value: data?.sprint, label: data?.sprint_number },
        name: "sprint",
      });
      dispatch({
        value: { value: data?.milestone, label: data?.milestone_name },
        name: "milestone",
      });
      dispatch({
        value: data?.attachment,
        name: "attachement",
      });
      fetchMileapi(data?.project);
      const updatedStakeHolders = data?.stake_holder?.map((item) => ({
        ...item,
        employee_name: item.user_name,
        id: item?.user_id,
      }));
      dispatch({
        value: { value: data?.teams, label: data?.teams },
        name: "teams",
      });
      setTaskCountId(data?.task_code);

      fetchAssginDependice(data?.team_name);

      dispatch({ value: updatedStakeHolders, name: "statusHolder" });
    }
  }, [data]);

  useEffect(() => {
    setEmployeeData([
      { id: 1, username: "John" },
      { id: 2, username: "Jane" },
      { id: 3, username: "Alice" },
    ]);
    fetchProjectData();
    fetchPriorityData();
    dispatch({
      value: currentUser?.employee_name,
      name: "reporter",
    });
    fetchTeamMembers();
  }, []);

  const handleMultipleSelect = (event, newValue) => {
    setSelectedEmployees(newValue);
    dispatch({ value: newValue, name: "statusHolder" });
  };
  const handleMileChange = (e, s) => {
    console.log(e, 'eee');
    dispatch({ value: e, name: "milestone" });
    setSelectedStartDate(e?.startDate || null);
    setSelectedEndDate(e?.endDate || null);
  };

  const fetchProjectData = async () => {
    const formData = new FormData();
    formData.append("user_id", currentUser);
    try {
      const res = await postData("/api/getProject/", formData);

      if (res?.status) {
        setProjectNameOption(res?.data);
      } else {
        setProjectNameOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTeamMembers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        id: item.id,
        employee_name: item?.employee_name,
        team: item.team?.team_name,
      }));
      setTeamMembersData(transformedData);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };
  const fetchPriorityData = async () => {
    try {
      const data = await fetchData("api/priority/");

      const status = data?.status;
      if (status) {
        setPriorityOption(data?.data);
      } else {
        setPriorityOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAdd = async () => {
    const newId = taskData?.statusHolder?.map((v) => ({
      user_id: v.id,
    }));

    const formdata = new FormData();

    formdata.append("project_id", taskData?.projectName?.value);
    formdata.append("task_title", taskData?.tasktitle);
    formdata.append("task_describtion", taskData?.taskDescrpition);
    formdata.append("team_name", taskData?.teams?.label);
    formdata.append("Assignee_id", taskData?.assignemnt?.value);
    formdata.append("task_creater_id", currentUser);
    if (taskData?.statusHolder?.length) {
      formdata.append("stake_holder", JSON.stringify(newId));
    } else {
      formdata.append("stake_holder", JSON.stringify(taskData?.statusHolder));
    }
    formdata.append("start_date", taskData?.startDate);
    formdata.append("end_date", taskData?.endDate);
    formdata.append("assigned_hours", taskData?.assginHours);
    formdata.append("milestone_id", taskData?.milestone?.value);
    formdata.append("module", taskData?.moduleName);
    formdata.append("attachment", taskData?.attachement ?? "");
    formdata.append("priority_level", taskData?.priority?.label);
    try {
      setCirleLoading(true);
      const data = await postData("api/taskcreation/", formdata);
      if (data?.status) {
        showSnackbar(data?.message, "success");
        navigate("/task-creation");
      } else {
        showSnackbar(data?.message, "error");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleFileSelect = (file) => {
    dispatch({
      value: file,
      name: "attachement",
    });
  };

  const fetchAssginDependice = (value) => {
    const filterData = allocatedMembers?.filter(
      (v, i) => v?.team?.toLowerCase() === value?.toLowerCase()
    );
    setAssginMembersOption(filterData);
  };

  const handleTeamChange = async (e, s) => {
    const value = e?.label;
    if (e) {
      fetchAssginDependice(value);
    }

    dispatch({ value: e, name: s?.name });
  };

  const fetchTeamsDependince = async (id) => {
    try {
      const formdata = new FormData();
      formdata.append("project_id", id);
      const data = await postData("/api/getallocatedresources/", formdata);

      const status = data?.status;
      if (status) {
        let team = [];
        if (data?.data) {
          data?.data?.map((item) => {
            if (!team.includes(item?.team)) {
              team.push(item?.team);
            }
          });

          setTeam(team)
        }

        setAllocatedMembers(data?.data);
      } else {
        setAllocatedMembers([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleProductChange = async (e, s) => {
    const id = e?.value;
    console.log(id, 'idddd')
    if (e) {
      fetchTeamsDependince(id);
      fetchChatBotData(id);
      fetchMileapi(id);
      fetchTaskCode(id);
    } else {
      setAllocatedMembers([]);
      setChatBotStatus(false);
      setTaskCountId("");
    }
    dispatch({ value: e, name: s?.name });
  };

  const fetchTaskCode = async (id) => {
    const formdata = new FormData();
    formdata.append("project_id", id);
    try {
      const data = await postData("/api/getTaskCount/", formdata);
      if (data?.status) {
        setTaskCountId(data?.data?.task_count);
      } else {
        setTaskCountId("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMileapi = async (id) => {
    const formData = new FormData();
    formData.append("project_id", id);
    try {
      const res = await postData("/api/getMilestone/", formData);

      if (res?.status) {
        setMileStoneOption(res?.data);
      } else {
        setMileStoneOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchChatBotData = async (id) => {
    setCirleLoading(true);

    try {
      const res = await fetchData(`/ai/suggest-employee/${id}/`);

      if (res) {
        setChatBotStatus(true);
        const suggestionText = res.suggestion;
        setSuggestion(suggestionText);
      }
    } catch (error) {
      console.error("Error fetching suggestion:", error);

      setSuggestion("Error fetching suggestion.");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate, "formatted date");

    dispatch({ value: formattedDate, name: "startDate" });
  };

  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`; 

    console.log(formattedDate, "formatted date");

    dispatch({ value: formattedDate, name: "endDate" });
  };


  const handleUpdate = async () => {
    const newId = taskData?.statusHolder?.map((v) => ({
      user_id: v.id,
    }));

    const formdata = new FormData();

    formdata.append("project_id", taskData?.projectName?.value);
    formdata.append("task_title", taskData?.tasktitle);
    formdata.append("task_describtion", taskData?.taskDescrpition);
    formdata.append("team_name", taskData?.teams?.label);
    formdata.append("Assignee_id", taskData?.assignemnt?.value);
    formdata.append("task_creater_id", currentUser);
    if (taskData?.statusHolder?.length) {
      formdata.append("stake_holder", JSON.stringify(newId));
    } else {
      formdata.append("stake_holder", JSON.stringify(taskData?.statusHolder));
    }
    formdata.append("start_date", taskData?.startDate);
    formdata.append("end_date", taskData?.endDate);
    formdata.append("assigned_hours", taskData?.assginHours);
    formdata.append("milestone_id", taskData?.milestone?.value);
    formdata.append("sprint_id", taskData?.sprint?.value);
    formdata.append("module", taskData?.moduleName);
    if (taskData?.attachement instanceof File) {
      formdata.append("attachment", taskData.attachement);
    }
    formdata.append("priority_level", taskData?.priority?.label);
    try {
      setCirleLoading(true);
      const res = await putData(`api/taskcreation/${data?.id}/`, formdata);
      if (res?.status) {
        showSnackbar(res?.message, "success");
        navigate("/task-creation");
      } else {
        showSnackbar(res?.message, "error");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      taskData.projectNameStatus === "success" &&
      taskData.tasktitleStatus === "success" &&
      taskData.teamsStatus === "success" &&
      taskData.assignemntStatus === "success" &&
      taskData.reporterStatus === "success" &&
      taskData.startDateStatus === "success" &&
      taskData.endDateStatus === "success" &&
      taskData.assginHoursStatus === "success" &&
      taskData.milestoneStatus === "success" &&
      taskData.moduleNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Task Creation
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        {chatBotStatus && (
          <div className="chatbox-container">
            <ChatBot suggestionText={suggestion} />
          </div>
        )}

        <CardContent sx={{ minHeight: "90vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Project Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="projectName"
                  value={taskData?.projectName}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={projectNameOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.project_name,
                      startDate: item?.start_date,
                      endDate: item?.end_date,
                    };
                  })}
                  isLoading={projectLoading}
                  onChange={(e, s) => handleProductChange(e, s)}
                  isClearable
                  error={taskData?.projectNameStatus === "error" ? true : false}
                  success={
                    taskData?.projectNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task code
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={taskCountId}
                  name="tasktitle"
                  placeholder="Enter Task Code"
                  disabled={true}
                  success={taskCountId ? true : false}
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Milestone <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="milestone"
                  value={taskData?.milestone}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={taskData?.projectName ? inputDisble : true}
                  options={mileStoneOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.milestone_name,
                      startDate: item?.start_date,
                      endDate: item?.end_date,
                    };
                  })}
                  onChange={(e, s) => handleMileChange(e, s)}
                  isClearable
                  error={taskData?.milestoneStatus === "error" ? true : false}
                  success={
                    taskData?.milestoneStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Module Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={taskData?.moduleName}
                  name="moduleName"
                  placeholder="Enter Module Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "moduleName" })
                  }
                  error={taskData.moduleNameStatus === "error" ? true : false}
                  success={
                    taskData.moduleNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task title <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={taskData?.tasktitle}
                  name="tasktitle"
                  placeholder="Enter Task title"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "tasktitle" })
                  }
                  error={taskData.tasktitleStatus === "error" ? true : false}
                  success={
                    taskData.tasktitleStatus === "success" ? true : false
                  }
                />
                {taskData.tasktitleStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>
                      Task title must be between 1 and 100 letters.{" "}
                    </FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={3}
                  value={taskData?.taskDescrpition}
                  name="taskDescrpition"
                  placeholder="Enter Task description"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "taskDescrpition",
                    })
                  }
                  error={
                    taskData.taskDescrpitionStatus === "error" ? true : false
                  }
                  success={
                    taskData.taskDescrpitionStatus === "success" ? true : false
                  }
                />
                {taskData.taskDescrpitionStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>
                      Task description must be between 1 and 250 letters.{" "}
                    </FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Designation <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="teams"
                  value={taskData?.teams}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={taskData?.projectName ? inputDisble : true}
                  options={team?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => handleTeamChange(e, s)}
                  isClearable
                  error={taskData?.teamsStatus === "error" ? true : false}
                  success={taskData?.teamsStatus === "success" ? true : false}
                />
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assign Member <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="assignemnt"
                  value={taskData?.assignemnt}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={taskData?.teams ? inputDisble : true}
                  options={assginMembersOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.employee_name,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  isClearable
                  error={taskData?.assignemntStatus === "error" ? true : false}
                  success={
                    taskData?.assignemntStatus === "success" ? true : false
                  }
                />
              </Grid>
              {/* <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task Repoter <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={currentUser?.firstName + currentUser?.lastName}
                  name="reporter"
                  placeholder="Enter Task title"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "reporter" })
                  }
                  error={taskData.reporterStatus === "error" ? true : false}
                  success={taskData.reporterStatus === "success" ? true : false}
                />
              </Grid> */}
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Stake Holder
                  </MaterialTypography>
                </MaterialBox>
                <MultiSelectAutocomplete
                  id="employee-selector"
                  placeholder="Add employees"
                  options={teamMembersData.map((member) => ({
                    employee_name: member.employee_name,
                    id: member.id,
                    teams: member?.team,
                  }))}
                  value={taskData?.statusHolder}
                  onChange={handleMultipleSelect}
                  disabled={taskData?.projectName ? inputDisble : true}
                  labelKey="employee_name"
                />
              </Grid>
              <Grid size={{ md: 2, lg: 2, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Start Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialDatePicker
                  value={taskData?.startDate}
                  type="date"
                  name="startDate"
                  placeholder="Enter Task title"
                  disabled={inputDisble}
                  onChange={handleStartDateChange}
                  error={taskData.startDateStatus === "error" ? true : false}
                  success={
                    taskData.startDateStatus === "success" ? true : false
                  }
                  options={{
                    onDayCreate: (dObj, dStr, fp, dayElem) => {
                      const dayOfWeek = dayElem.dateObj.getDay();

                      if (selectedStartDate && selectedEndDate) {
                        const start = new Date(selectedStartDate).setHours(0, 0, 0, 0);
                        const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                        const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }

                        // ✅ Highlight full range in green
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#86C489";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }

                        // ✅ Make weekends inside project range blue
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          if (day >= start && day <= end) {
                            dayElem.style.backgroundColor = "#F3CBC9";
                            dayElem.style.color = "#fff";
                            dayElem.style.borderRadius = "50%";
                            dayElem.style.fontWeight = "bold";
                          }
                        }
                      } else {
                        // ✅ If no range selected, just mark weekends as red (outside project)
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }
                      }
                    },
                  }}
                />
              </Grid>
              <Grid size={{ md: 2, lg: 2, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    End Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialDatePicker
                  value={taskData?.endDate}
                  type="date"
                  name="endDate"
                  placeholder="Enter Task title"
                  disabled={taskData?.startDate ? inputDisble : true}
                  onChange={handleEndDateChange}
                  error={taskData.endDateStatus === "error" ? true : false}
                  success={taskData.endDateStatus === "success" ? true : false}
                  inputProps={{
                    min: taskData?.startDate,
                  }}
                  options={{
                    onDayCreate: (dObj, dStr, fp, dayElem) => {
                      const dayOfWeek = dayElem.dateObj.getDay();

                      if (selectedStartDate && selectedEndDate) {
                        const start = new Date(selectedStartDate).setHours(0, 0, 0, 0);
                        const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                        const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }

                        // ✅ Highlight full range in green
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#86C489";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }

                        // ✅ Make weekends inside project range blue
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          if (day >= start && day <= end) {
                            dayElem.style.backgroundColor = "#F3CBC9";
                            dayElem.style.color = "#fff";
                            dayElem.style.borderRadius = "50%";
                            dayElem.style.fontWeight = "bold";
                          }
                        }
                      } else {
                        // ✅ If no range selected, just mark weekends as red (outside project)
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }
                      }
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assign hours <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={taskData?.assginHours}
                  type="number"
                  name="assginHours"
                  placeholder="Enter Assigned hours"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "assginHours" })
                  }
                  error={taskData.assginHoursStatus === "error" ? true : false}
                  success={
                    taskData.assginHoursStatus === "success" ? true : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />

                {taskData?.contactNumberStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>Invalid Contact Number</FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>
              <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Priority <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priority"
                  value={taskData?.priority}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={priorityOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.priority,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  isClearable
                  isLoading={priorityLoading}
                  error={taskData?.priorityStatus === "error" ? true : false}
                  success={
                    taskData?.priorityStatus === "success" ? true : false
                  }
                />
              </Grid>



              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Attachement
                  </MaterialTypography>
                </MaterialBox>

                <FileSelector
                  onFileSelect={handleFileSelect}
                  fileUrl={data?.attachment}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              onClick={() => navigate("/task-creation")}
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
            >
              Cancel
            </MaterialButton>
            {type !== "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={type === "edit" ? handleUpdate : handleAdd}
              >
                {type === "edit" ? "Update" : "Submit"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default TaskCreationForm;
